/* Used to get all the query params from a url. */
export function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    groupId: params.get("groupId") ? params.get("groupId") : "",
    user: params.get("user") ? params.get("user") : "",
  };
}
